<div class="hex-input-container">
  <input
    type="text"
    (input)="onInputChange($event)"
    (blur)="onInputBlur($event)"
    (keypress)="validateInput($event)"
    [value]="currentColor"
    maxlength="6"
  />
</div>